function initSlider(sectionSelector, listSelector, prevSelector, nextSelector, dotsSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);
  const dotsContainer = section.querySelector(dotsSelector);

  if (!list) return;

  const items = list.children;
  const totalSlides = items.length;
  let current = 0;

  // Створюємо крапки
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        current = i;
        scrollToSlide();
      });
      dotsContainer.appendChild(dot);
    }
  }

  // Відстеження ручного скролу
  list.addEventListener('scroll', () => {
    const gap = parseInt(getComputedStyle(list).gap) || 0;
    const stepWidth = items[0].offsetWidth + gap; // Виправлено на items[0]
    const newIndex = Math.round(list.scrollLeft / stepWidth);

    if (newIndex !== current) {
      current = newIndex;
      updateDots();
    }
  });

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === current);
    });
  }

  function scrollToSlide() {
    const gap = parseInt(getComputedStyle(list).gap) || 0;
    const stepWidth = items[0].offsetWidth + gap; // Виправлено (було itemsInList)

    list.scrollTo({
      left: stepWidth * current,
      behavior: 'smooth'
    });

    updateDots();
  }

  const scroll = (direction) => {
    const max = totalSlides - 1;
    if (direction === 'next') {
      current = (current < max) ? current + 1 : 0;
    } else {
      current = (current > 0) ? current - 1 : max;
    }
    scrollToSlide();
  };

  // Автопрокрутка
  let autoScroll = setInterval(() => scroll('next'), 5000);

  section.addEventListener('mouseenter', () => clearInterval(autoScroll));
  section.addEventListener('mouseleave', () => {
    autoScroll = setInterval(() => scroll('next'), 5000);
  });

  // Додаємо обробку тач-подій (для телефонів зупиняємо автопрокрутку)
  list.addEventListener('touchstart', () => clearInterval(autoScroll), {passive: true});

  if (nextBtn) nextBtn.addEventListener('click', () => scroll('next'));
  if (prevBtn) prevBtn.addEventListener('click', () => scroll('prev'));
}

// Виклик функції
initSlider(
  '.gallery-section',
  '.gallery-steps',
  '.btn-prev',
  '.btn-next'
);

initSlider(
  '.item-section',
  '.item-steps',
  null,
  null
);


initSlider(
  '.visual-section',
  '.visual-steps',
  null,
  null,
);
